export default "/dist/files/notifications_vide.e053d9187fb1dba4b7af7af9c85267f1.svg";